<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id">
            <!-- 报文 -->
            <template slot="readParams" slot-scope="text,record">
                <a-icon style="color:#1890ff;" size="large" type="file-text" @click="handleParams(record)" />
            </template>
        </a-table>
        <a-pagination v-model="pagination.page" :total="pagination.total" :pageSize="pagination.pageSize"
            @change="handlePageChange" show-less-items style="float: right; margin-top: 20px" />
        <a-modal v-model="modalVisible" title="报文" @ok="handleOk">
        <a-tabs default-active-key="1">
            <a-tab-pane key="1" tab="请求参数">

                <json-viewer
                :value="currentRequest"
                :expand-depth=5
                copyable
                boxed
                sort></json-viewer>
            </a-tab-pane>
            <a-tab-pane key="2" tab="响应结果">
                <json-viewer
                :value="currentResponse"
                :expand-depth=5
                copyable
                boxed
                sort></json-viewer>
            </a-tab-pane>
        
            </a-tabs>
    </a-modal>
    </div>
</template>
<script>
import JsonViewer from "vue-json-viewer"

const columns = [
    {
        title: "报文",
        width:50,
        scopedSlots: { customRender: 'readParams' },
        align: "center",
        ellipsis: true,
        fixed: 'left'
    },
    {
        title: "appkey",
        width: 100,
        dataIndex: "appkey",
        align: "center",
        ellipsises: true,
    },
    {
        title: "appsecret",
        width: 120,
        dataIndex: "appsecret",
        align: "center",
        ellipsises: true,
    },
    
    {
        title: "sign",
        width:300,
        dataIndex: "sign",
        align: "center",
    },
    {
        title: "issuccess",
        width: 100,
        dataIndex: "issuccess",
        ellipsis: true,
        align: "center",
    },
    {
        title: "callbacknum",
        width: 100,
        dataIndex: "callbacknum",
        ellipsis: true,
        align: "center",
    },

    {
        title: "appenv",
        width: 100,
        dataIndex: "appenv",
        ellipsis: true,
        align: "center",
    },

    {
        title: "topic",
        width: 300,
        dataIndex: "topic",
        align: "center",
        ellipsises: true,
    },
    {
        title: "reqno",
        width: 500,
        dataIndex: "reqno",
        align: "center",
        ellipsises: true,
    },

    {
        title: "callbackurl",
        width: 500,
        dataIndex: "callbackurl",
        ellipsis: true,
        align: "center",
    },

    
    // {
    //     title: "requestdata",
    //     width: 100,
    //     dataIndex: "requestdata",
    //     align: "center",
    // },
    // {
    //     title: "response",
    //     width: 300,
    //     dataIndex:'response',
    //     ellipsis: true,
    //     align: "center",
    // },
    
    {
        title: "responseTime",
        width: 150,
        dataIndex: "responseTime",
        ellipsis: true,
        align: "center",
    },
    
    {
        title: "updatetime",
        width: 150,
        dataIndex: "updatetime",
        ellipsis: true,
        align: "center",
    },
    {
        title: "bussinesskey",
        width: 150,
        dataIndex: "bussinesskey",
        ellipsis: true,
        align: "center",
    },
    {
        title: "datetime",
        width: 150,
        dataIndex: "datetime",
        ellipsis: true,
        align: "center",
    },
    

    {
        title: "createtime",
        width: 150,
        dataIndex: "createtime",
        ellipsis: true,
        align: "center",
    },

    

];

export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            clientWidth:800,
            searchP:{},
            pagination: {
                total: 0,
                pageSize: 10,
                page: 1,
            },
            modalVisible:false,
            currentRequest:"",
            currentResponse:"",
        };
    },
    methods: {
        handleOk(){
            this.modalVisible = false;
        },
        handleParams(item){
            this.modalVisible = true;
            try {
                this.currentRequest = JSON.parse(item.requestdata);
            } catch (error) {
                this.currentRequest = item.requestdata;
            }
            
            try {
                this.currentResponse = JSON.parse(item.response);
            } catch (error) {
                this.currentResponse = item.response;
            }
        },
        handlePageChange(v) {
            this.pagination.page = v;
            this.getAppSumData();
        },
        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'open/callbackInfospage',
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.tableData = result.list;
                    that.pagination.total = parseInt(result.totalRecords);
                    that.pagination.pageSize = parseInt(result.pageSize);
                    that.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        },
    },

    components:{
        JsonViewer
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

